<script setup lang="ts">
import RialticLogo from '../logo/Rialtic.vue'
</script>

<template>
  <div class="bg-surface fixed inset-0 h-screen w-full">
    <div class="flex h-full items-center justify-center p-4">
      <RialticLogo class="h-40 w-40 animate-pulse" icon />
    </div>
  </div>
</template>
